export const PAGE_TITLE = "Thank You Page & Upsells";
export const LISTING_UUID_SEARCH_KEY = "listing_uuid";
